module.exports = __webpack_public_path__ + "static/media/games.1e73d566.jpg";